import { render, staticRenderFns } from "./PipelineMenu.vue?vue&type=template&id=7008a4e8&scoped=true&"
import script from "./PipelineMenu.vue?vue&type=script&lang=ts&"
export * from "./PipelineMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PipelineMenu.vue?vue&type=style&index=0&id=7008a4e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008a4e8",
  null
  
)

export default component.exports